import { useContext } from 'react'

import { Box, CircularProgress } from '@mui/material'

import { routes } from '@redwoodjs/router'

import { DayContext } from 'src/lib/dayContext'

const WorkspaceSettingsPageRedirect = () => {
  const { selectedWorkspace } = useContext(DayContext)

  if (selectedWorkspace) {
    window.location.href = routes.workspaceSettings({
      id: selectedWorkspace,
      tab: 'notifications',
    })
    return
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  )
}

export default WorkspaceSettingsPageRedirect
